import React from 'react';
import funnel1 from '../assets/images/funnel1.svg';
import funnel2 from '../assets/images/funnel2.svg';
import funnel3 from '../assets/images/funnel3.svg';
import funnel4 from '../assets/images/funnel4.svg';
import funnel5 from '../assets/images/funnel5.svg';
import funnelStrick1 from '../assets/images/funnelStick1.svg';
import funnelStrick2 from '../assets/images/funnelStick2.svg';
import funnelStrick3 from '../assets/images/funnelStick3.svg';
import funnelStrick4 from '../assets/images/funnelStick4.svg';
import funnelStrick5 from '../assets/images/funnelStick5.svg';
import { RecruitingFunnel } from '../models/recruitingFunnel.model';

interface DashboardFunnelProps {
	recruitingFunnel: RecruitingFunnel;
}
const DashboardFunnel: React.FC<DashboardFunnelProps> = ({
	recruitingFunnel,
}) => {
	return (
		//NOTE:The below graph was done with images, need to change it if required.
		<div className="flex flex-col h-full w-full overflow-auto">
			<div className="font-semibold">Recruiting Funnel</div>
			<div className="scale-[0.8] xl:scale-[1] 3xl:scale-[1.25] basis-full flex flex-col justify-center min-w-[550px]">
				<div className="flex justify-center w-full">
					<span className="relative right-36">
						<img src={funnel1}></img>
						<img
							src={funnelStrick1}
							className={'absolute top-[50%] left-[95%]'}
						></img>
						<span
							className={
								'absolute top-[50%] left-[140%] translate-y-[-35%]'
							}
						>
							Leads
						</span>
						<span className="absolute text-white left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%] font-medium text-3xl">
							{recruitingFunnel?.leads}
						</span>
					</span>
				</div>
				<div className="flex justify-center w-full pt-2">
					<span className="relative right-36">
						<img src={funnel2}></img>
						<img
							src={funnelStrick2}
							className={'absolute top-[50%] left-[93%]'}
						></img>
						<span
							className={
								'absolute top-[50%] left-[147%] translate-y-[-35%]'
							}
						>
							Prospects
						</span>
						<span className="absolute text-white left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%] font-medium text-3xl">
							{recruitingFunnel?.prospects}
						</span>
					</span>
				</div>
				<div className="flex justify-center w-full pt-2">
					<span className="relative right-36">
						<img src={funnel3}></img>
						<img
							src={funnelStrick3}
							className={'absolute top-[50%] left-[91%]'}
						></img>
						<span
							className={
								'absolute top-[50%] left-[159%] translate-y-[-35%] w-[150px]'
							}
						>
							Due diligence
						</span>
						<span className="absolute text-white left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%] font-medium text-3xl">
							{recruitingFunnel?.due_diligence}
						</span>
					</span>
				</div>
				<div className="flex justify-center w-full pt-2">
					<span className="relative right-36">
						<img src={funnel4}></img>
						<img
							src={funnelStrick4}
							className={'absolute top-[50%] left-[88%]'}
						></img>
						<span
							className={
								'absolute top-[50%] left-[180%] translate-y-[-35%] w-[150px]'
							}
						>
							Site visit
						</span>
						<span className="absolute text-white left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%] font-medium text-3xl">
							{recruitingFunnel?.site_visit}
						</span>
					</span>
				</div>
				<div className="flex justify-center w-full pt-2">
					<span className="relative right-36">
						<img src={funnel5}></img>
						<img
							src={funnelStrick5}
							className={
								'absolute top-[30%] left-[75%] scale-125'
							}
						></img>
						<span
							className={
								'absolute top-[30%] left-[210%] translate-y-[-35%]'
							}
						>
							Offer
						</span>
						<span className="absolute text-white left-[50%] top-[30%] translate-y-[-50%] translate-x-[-50%] font-medium text-3xl">
							{recruitingFunnel?.offer}
						</span>
					</span>
				</div>
			</div>
		</div>
	);
};

export default DashboardFunnel;
